import React, { useState } from 'react';
import { connect } from '../../redux/store';
import { compose, lifecycle } from 'recompose';
import { Router } from '@reach/router';
import { bundle } from '@kineticdata/react';
import {
  ErrorMessage,
  LoadingMessage,
  TableComponents,
} from '@kineticdata/bundle-common';
import { PageTitle } from '../shared/PageTitle';
import { actions } from '../../redux/modules/adminForms';
import { FormSettings } from './FormSettings';
import { Submission } from './Submission';
import { FormDetails } from './FormDetails';
import { FormsList } from './FormsList';

const tableKey = 'admin-forms-list';

// Wrapper for components that require the form object
export const FormSettingsWrapper = compose(
  connect(
    state => ({
      form: state.adminForms.form,
      error: state.adminForms.error,
    }),
    {
      fetchFormRequest: actions.fetchFormRequest,
      fetchSubmissionsReset: actions.fetchSubmissionsReset,
    },
  ),
  lifecycle({
    componentDidMount() {
      bundle.adminDatastore = true;
      this.props.fetchFormRequest({
        kappSlug: 'admin',
        formSlug: this.props.formSlug,
      });
    },
    componentWillUnmount() {
      delete bundle.adminDatastore;
      this.props.fetchSubmissionsReset();
    },
  }),
)(
  ({ formSlug, form, error, match }) =>
    error || !form || form.slug !== formSlug ? (
      <div className="page-container">
        <div className="page-panel">
          <PageTitle
            parts={[form && form.name, `Admin Forms`]}
            breadcrumbs={[{ label: 'Admin Forms', to: '/settings/adminforms' }]}
            title={'Admin Form'}
          />
          {error ? (
            <ErrorMessage message={error.message} />
          ) : (
            <LoadingMessage />
          )}
        </div>
      </div>
    ) : (
      <Router>
        <FormSettings path="settings" form={form} />
        <Submission form={form} path="submissions/new/:cloneId" />
        <Submission form={form} path="submissions/new" exact />
        <Submission form={form} path="submissions/:id" />
        <FormDetails default form={form} />
      </Router>
    ),
);

export const AdminForms = () => {
  const [pageSize, setPageSize] = useState(25);
  return (
    <Router>
      <TableComponents.MountWrapper tableKey={tableKey} default>
        <FormSettingsWrapper path=":formSlug/*" />
        <FormsList
          tableKey={tableKey}
          pageSize={pageSize}
          setPageSize={setPageSize}
          default
        />
      </TableComponents.MountWrapper>
    </Router>
  );
};
